import React, { Component } from 'react';

import { WithStyles, createStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { Grid, Typography, Button, MenuItem } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import { SearchField } from '../../../common';
import CloseRounded from '@material-ui/icons/Cancel';
import { showMsg } from '../../actions/loaderAlert';
import { bindActionCreators } from 'redux'

import _ from 'lodash';
import cx from 'classnames';

import advanceSettingService from "../../services/advancedSettingService"
import { connect } from 'react-redux';
import GoalsDriller from '../../components/GoalsDriller'
import { styles } from '../../styling/component/AdvanceSetting/BatchesSyllabusContent'


interface BatchesSyllabusContentProps extends WithStyles<typeof styles> {
	showMsg: (msg: string, vari: string) => void,
	setAddedBatchesContent: Function,
	toggleInstructorBatchCard: Function,
	instructorKey: any,
	instructorValue: any,
	addedBatches: any[],
	cardFlag: any,
	setCountSubjectRemove:any,
	subjectRemoved:number,
}

interface BatchesSyllabusContentState {
	addedBatches: any[],
	searchBatchText: String,
	searchBatchArr: any[],
	batchActive: any,
	batchesArray: any[],
	searchInstructorArr: any[],
	searchInstructorText: String,
	mapMoreView: boolean,
	selectedInstructorID: string,
	showSuggestedConcept: boolean,
	suggestedConcept: any[],
	activeItem: string | 'classes' | 'subjects' | 'subSubjects' | 'chapters' | 'concepts',
	activeItemSet: any[],
}

class BatchesSyllabusContent extends Component<BatchesSyllabusContentProps, BatchesSyllabusContentState> {
	constructor(props: BatchesSyllabusContentProps) {
		super(props);

		this.state = {
			addedBatches: [],
			searchBatchText: "",
			searchBatchArr: [],
			batchActive: "",
			batchesArray: [],
			searchInstructorArr: [],
			searchInstructorText: "",
			mapMoreView: false,
			selectedInstructorID: "",
			showSuggestedConcept: false,
			suggestedConcept: [],
			activeItem: 'classes',
			activeItemSet: [],
		}

		this.handleSearchBatches = this.handleSearchBatches.bind(this);
		this.searchBatches = this.searchBatches.bind(this);
		this.addBatches = this.addBatches.bind(this)
		this.removeBatches = this.removeBatches.bind(this)
		this.clickOnBatch = this.clickOnBatch.bind(this)
		this.backToBatch = this.backToBatch.bind(this)

		this.removeInstructor = this.removeInstructor.bind(this)
		this.handleInstructorSearch = this.handleInstructorSearch.bind(this)
		this.addInstructor = this.addInstructor.bind(this)
		this.removeSubject = this.removeSubject.bind(this)
		this.enableMapMoreView = this.enableMapMoreView.bind(this)
		this.showSuggestedConcept = this.showSuggestedConcept.bind(this)
		this.addSubjectConcept = this.addSubjectConcept.bind(this)
		this.handleCheckboxChange = this.handleCheckboxChange.bind(this)
	}


	getMandatoryTags() {
		let self = this
		advanceSettingService.getMandatoryTags().then((responseData: any) => {
			if (!_.isEmpty(responseData) && responseData.length > 0) {
				self.setState({
					//mandatoryTags:responseData
				})
			}
		});
	}

	componentDidUpdate(prevProps: any, prevState: any) {
		const { instructorKey, instructorValue, addedBatches, setAddedBatchesContent, cardFlag } = this.props;
		const {batchActive} = this.state
		// on click of batch in course main page update state
		if (cardFlag !== "") {
			const { batchActive: { _id: prevKey, name: prevVal } }: any = this.state;
			if (!_.isEmpty(instructorKey) && !_.isEmpty(instructorValue)) {
				const hasAlready: any = !_.isEmpty(_.find(addedBatches, ['_id', instructorKey]));

				if (!_.isEqual(prevKey, instructorKey) && !_.isEqual(prevVal, instructorValue)) {
					let newAddedBatches: any = [...addedBatches];

					if (!hasAlready) {
						const newBatch: any = {
							_id: instructorKey,
							name: instructorValue,
							students: [],
							instructors: [],
						};
						newAddedBatches.push(newBatch);
					}

					this.setState({
						batchActive: { _id: instructorKey, name: instructorValue },
						mapMoreView: false,
						selectedInstructorID: "",
					});

					setAddedBatchesContent(addedBatches);

				}
			}
		}
		else {
			if (batchActive != "") {
				this.setState({
					batchActive: ""
				})
			}
		}
	}

	handleSearchBatches(event: any) {
		var self = this
		self.searchBatches(event.currentTarget.value)
	}

	searchBatches(searchTxt: string) {
		var self = this;
		const { addedBatches } = this.props;
		const { searchBatchArr } = this.state;

		if (searchTxt == "") {
			self.setState({
				searchBatchArr: []
			})
		}

		if (searchTxt.length < 2) {
			return
		}

		var selectedArrTemp = addedBatches.map(function (value: any) {
			return value._id
		})
		var selectedArr = selectedArrTemp.join(",") || ""

		advanceSettingService.searchBatches(selectedArr, searchTxt.replace(/[^A-Z0-9]+/ig, "_")).then((responseData: any) => {
			if (!_.isEmpty(responseData) && responseData !== "Package Not Found") {
				self.setState({
					searchBatchArr: responseData
				})
			}
		});
	}

	addBatches(event: any, batchData: any) {
		var name = batchData.name
		var key = batchData._id
		let { addedBatches, setAddedBatchesContent } = this.props

		var dataArr = addedBatches.filter(function (value: any) {
			return value._id == key
		})
		if (dataArr.length == 0) {
			addedBatches.push({
				"_id": key,
				"name": name,
				"instructors": [],
				"students": batchData.students
			});
			this.setState({
				searchBatchText: "",
				searchBatchArr: []
			});
			setAddedBatchesContent(addedBatches);
		} else {
			this.props.showMsg("Batch Already Added.", 'error')
		}
	}

	removeBatches(id: any) {
		let { addedBatches, setAddedBatchesContent } = this.props;

		const dataArr = addedBatches.filter(function (value: any) {
			return value._id !== id
		});

		this.setState({
			mapMoreView: false
		});

		setAddedBatchesContent(dataArr);
	}

	clickOnBatch(event: any) {
		var name = event.currentTarget.getAttribute("data-name")
		var key = event.currentTarget.getAttribute("data-id")

		this.setState({
			batchActive: { _id: key, name: name },
			mapMoreView: false,
			selectedInstructorID: ""
		})
		this.props.toggleInstructorBatchCard(key);
	}

	backToBatch() {
		this.setState({
			batchActive: "",

		})

		this.props.toggleInstructorBatchCard("")
	}

	//Instructor
	handleInstructorSearch(event: any) {
		var self = this
		self.searchInstructor(event.currentTarget.value)
	}

	searchInstructor(searchTxt: string) {
		var self = this;
		const { addedBatches } = this.props;
		const { searchInstructorArr } = this.state;

		if (searchTxt == "") {
			self.setState({
				searchInstructorArr: []
			})
		}

		if (searchTxt.length < 2) {
			return
		}

		var selectedArrTemp = addedBatches.map(function (value: any) {
			return value._id
		})
		var selectedArr = selectedArrTemp.join(",") || ""

		advanceSettingService.getSearchIntructors("", searchTxt.replace(/[^A-Z0-9]+/ig, "_")).then((responseData: any) => {
			if (!_.isEmpty(responseData)) {
				self.setState({
					searchInstructorArr: responseData
				})
			}
		});
	}

	addInstructor(event: any) {
		var name = event.currentTarget.getAttribute("data-name")
		var key = event.currentTarget.getAttribute("data-id")
		var listIndex = event.currentTarget.getAttribute("data-index")

		let { addedBatches, setAddedBatchesContent } = this.props;
		var { batchActive, searchInstructorArr } = this.state
		var _indexKey = _.findIndex(addedBatches, function (o: any) { return o._id == batchActive._id; });
		var _getInstructorArr = addedBatches[_indexKey].instructors;
		var _checkExistence = _.findIndex(_getInstructorArr, function (o: any) { return o._id == key; });
		if (_checkExistence == -1) {
			_getInstructorArr.push({
				"_id": key,
				"name": name,
				"subjects": searchInstructorArr[listIndex].subjects
			})

			addedBatches[_indexKey].instructors = _getInstructorArr

			this.setState({
				searchInstructorText: "",
				searchInstructorArr: []
			});
			setAddedBatchesContent(addedBatches);
		} else {
			this.props.showMsg("Intructor Already Added.", 'error')
		}
	}

	removeInstructor(id: any) {
		let { addedBatches, setAddedBatchesContent } = this.props;
		var { batchActive } = this.state
		var _indexKey = _.findIndex(addedBatches, function (o: any) { return o._id == batchActive._id; });
		var _getInstructorArr = addedBatches[_indexKey].instructors
		var _getInstructorArr = _getInstructorArr.filter(function (v: any) {
			return v._id != id
		})

		addedBatches[_indexKey].instructors = _getInstructorArr

		this.setState({
			mapMoreView: false,
		});
		setAddedBatchesContent(addedBatches);
	}

	removeSubject(value: string, intructorID: string) {
		let { addedBatches, setAddedBatchesContent,setCountSubjectRemove } = this.props;

		var { batchActive } = this.state
		var _indexKey = _.findIndex(addedBatches, function (o: any) { return o._id == batchActive._id; });
		var _getInstructorArr = addedBatches[_indexKey].instructors;
		var _getIntructorIndex = _.findIndex(_getInstructorArr, function (o: any) { return o._id == intructorID; });

		if (_getIntructorIndex !== -1) {
			var subjectArr = _getInstructorArr[_getIntructorIndex].subjects
			var newSubjectArr = subjectArr.filter(function (v: string) {
				return v.trim() != value.trim()
			})
			_getInstructorArr[_getIntructorIndex].subjects = newSubjectArr
			addedBatches[_indexKey].instructors = _getInstructorArr
			setAddedBatchesContent(addedBatches);
			setCountSubjectRemove();
		}

	}


	addSubjectConcept(value: string) {
		let { addedBatches, setAddedBatchesContent } = this.props;
		var { batchActive, selectedInstructorID } = this.state
		var _indexKey = _.findIndex(addedBatches, function (o: any) { return o._id == batchActive._id; });
		var _getInstructorArr = addedBatches[_indexKey].instructors;
		var _getIntructorIndex = _.findIndex(_getInstructorArr, function (o: any) { return o._id == selectedInstructorID; });

		if (_getIntructorIndex !== -1) {
			var subjectArr = _getInstructorArr[_getIntructorIndex].subjects
			var newSubjectArr = subjectArr.filter(function (v: string) {
				return v.trim() != value.trim()
			})
			newSubjectArr.push(value)
			_getInstructorArr[_getIntructorIndex].subjects = newSubjectArr
			addedBatches[_indexKey].instructors = _getInstructorArr

			setAddedBatchesContent(addedBatches);
		}
		this.forceUpdate()
	}

	handleCheckboxChange(event: any) {
		var { selectedInstructorID } = this.state
		let checkValue = event.target.checked
		let checkbocText = event.target.value

		checkValue ? this.addSubjectConcept(checkbocText) : this.removeSubject(checkbocText, selectedInstructorID)
	}

	enableMapMoreView(selectedInstructorID: string) {
		this.setState({
			mapMoreView: true,
			selectedInstructorID: selectedInstructorID
		})

	}

	showSuggestedConcept(action: boolean) {
		if (action) {
			this.setState({ showSuggestedConcept: true });
		} else {
			setTimeout(() => { this.setState({ showSuggestedConcept: false }); }, 200)
		}
	}

	searchConceptChapter(event: any) {
		var self = this;
		const { addedBatches } = this.props;
		const { searchInstructorArr } = this.state;
		let searchTxt = event.currentTarget.value
		if (searchTxt == "") {
			self.setState({
				searchInstructorArr: []
			})
		}

		if (searchTxt.length < 2) {
			return
		}

		var selectedArrTemp = addedBatches.map(function (value: any) {
			return value._id
		})
		var selectedArr = selectedArrTemp.join(",") || ""

		advanceSettingService.searchSyllabus("5ace202e9fe7b01d5806bb73,5d0cd86260ab3f501de526d4", searchTxt.replace(/[^A-Z0-9]+/ig, "_")).then((responseData: any) => {
			if (!_.isEmpty(responseData)) {
				self.setState({
					suggestedConcept: responseData
				})
			}
		});
	}

	render() {
		let { classes, addedBatches } = this.props;

		let { searchBatchArr, batchActive, searchInstructorArr, mapMoreView, showSuggestedConcept, suggestedConcept } = this.state
		let self = this;
		let _indexKey = _.findIndex(addedBatches, function (o: any) { return o._id == batchActive._id; });
		let intructorArray : any = []
		let subjectArray : any = []
		if (_indexKey !== -1) {
			intructorArray = addedBatches[_indexKey].instructors || []
			subjectArray = intructorArray.subjects
		}
		let courseID = (window.location.href)
		courseID = courseID.substring(courseID.lastIndexOf("/") + 1, courseID.length)

		return (
			<>
				{

					batchActive == "" ?
						<Grid container xs={12} style={{ marginBottom: "50px" }} className={cx(classes.wrapperMain, classes.borderDefault, classes.marginTop10)}>
							<Typography variant="h6" style={{ padding: "10px" }}>
								Add Batches
									</Typography>
							<Grid container>
								{
									addedBatches.map((value: any, index: any) => {
										return <div key={`${value._id} ${index}`} className={classes.breadCrumbs}>
											<span data-id={value._id} data-name={value.name}
											// onClick={self.clickOnBatch}
											>{value.name}
											</span> <CloseRounded onClick={() => { self.removeBatches(value._id) }} />
										</div>
									})
								}
								<Grid item xs={12} className={cx(classes.searchWrapper)}>
									<SearchField
										fullWidth
										placeholder="Search Batches"
										className={classes.searchConceptRoot}
										onChange={this.handleSearchBatches.bind(this)}
										inputProps={{
											autoComplete: "off"
										}}
									/>
									<div >
										{
											searchBatchArr.map((value: any, index: any) => {
												return <Paper className={classes.paper} square>
													<MenuItem
														key={value._id}
														data-id={value._id}
														data-name={value.name}
														component="div"
														onClick={(e) => self.addBatches(e, value)}
														style={{
															fontWeight: 500,
														}}
													>
														{value.name}
													</MenuItem>
												</Paper>
											})
										}
									</div>
								</Grid>
							</Grid>
						</Grid>
						:
						<Grid container xs={12} style={{ marginBottom: "50px" }} className={cx(classes.wrapperMain, classes.borderDefault, classes.marginTop10)}>
							<Typography variant="h6" style={{ padding: "10px" }}>
								<span onClick={self.backToBatch}>{batchActive.name}  > </span>Add Instructors
					</Typography>
							<Grid container>
								<Grid
									container
									direction="row"
									justify="flex-start"
									alignItems="center"
									style={{ marginBottom: "20px" }}
								>
									<Grid container>
										<Grid item xs={12} className={cx(classes.searchWrapper)}>
											<SearchField
												placeholder="Search User Name"
												className={classes.searchConceptRoot}
												onChange={this.handleInstructorSearch.bind(this)}
												inputProps={{
													autoComplete: "off"
												}}
												fullWidth
											/>
											<div>
												{
													searchInstructorArr.map((value: any, index: any) => {
														return <Paper className={classes.paper} square key={index}>
															<MenuItem
																key={`${value._id} ${index}`}
																data-id={value._id}
																data-name={value.name}
																data-index={index}
																component="div"
																onClick={self.addInstructor}
																style={{
																	fontWeight: 500,
																}}
															>
																{value.name}
															</MenuItem>
														</Paper>
													})
												}
											</div>
										</Grid>
									</Grid>
									<Grid container className={classes.margin} >
										{
											intructorArray.length > 0 ?
												<>
													<Grid item xs={3}>
														<Typography variant="body2">
															Instructors
													</Typography>
													</Grid>
													<Grid item xs={9}>
														<Typography variant="body2" >
															Syllabus Mapped
													</Typography>
													</Grid>
												</>
												:
												<></>
										}

										{
											// 	<div key={value.id}  className={classes.breadCrumbs}>
											// 	{value.name} <CloseRounded onClick={() => { self.removeInstructor(value.id) }} />
											// </div>

											intructorArray.map((value: any, index: any) => {
												return <>
													<Grid item xs={3}>
														<Typography variant="body1" style={{ marginTop: "10px", marginBottom: "10px" }}>
															{value.name}
															<span className={cx(classes.link)} style={{ marginLeft: "10px" }} onClick={() => { self.removeInstructor(value._id) }} >
																Remove
														</span>
														</Typography>
													</Grid>
													<Grid item xs={9}>

														<Typography variant="body1" style={{ marginTop: "10px", marginBottom: "10px", lineHeight: 2.5 }}>
															{
																value.subjects.map(function (v: any, i: number) {
																	return <span className={classes.breadSyllabus}>
																		{v} <CloseRounded onClick={() => { self.removeSubject(v, value._id) }} />
																	</span>
																})
															}
															<span onClick={() => this.enableMapMoreView(value._id)} className={classes.link} style={{ marginLeft: "10px" }}>
																Map More
															</span>
														</Typography>

													</Grid>
												</>
											})
										}
									</Grid>
									{mapMoreView && <div className={classes.borderBox}>
										<Grid container>
											<Grid item xs={12} className={classes.searchConceptBox}>
												<Typography variant="body1" gutterBottom>
													Search Syllabus
             									</Typography>
												<div className={classes.suggestContainer}>
													<SearchField
														placeholder="Search Concept &amp; Chapter"
														className={classes.searchConceptRoot}
														onFocus={() => { this.showSuggestedConcept(true) }}
														onBlur={() => { this.showSuggestedConcept(false) }}
														onChange={this.searchConceptChapter.bind(this)}
														fullWidth
													/>

													{
														showSuggestedConcept && suggestedConcept.length > 0 && (
															<ul className={classes.suggestList}>
																{
																	_.map(suggestedConcept, (sc, i: number) => (
																		<li key={i} className={classes.suggestItem} onClick={() => { self.addSubjectConcept(sc.name) }}>
																			{sc.name}
																		</li>
																	))
																}
															</ul>
														)
													}
												</div>
											</Grid>
											<Grid item xs={12} className={classes.exploreConceptBox}>
												<Typography variant="body1" gutterBottom>
													Explore Syllabus
             									</Typography>
												<Grid container spacing={16}>
													<GoalsDriller handleCheckboxChange={this.handleCheckboxChange} goalsDriller="" />
												</Grid>
											</Grid>
										</Grid>
									</div>
									}
								</Grid>
							</Grid>
						</Grid>
				}
			</>
		)
	}
}
// @ts-ignore
const mapDispatchToProps = (dispatch: any) => bindActionCreators(
	{
		showMsg: showMsg
	},
	dispatch
);


// @ts-ignore
export default connect(null, mapDispatchToProps)(withStyles(styles)(BatchesSyllabusContent));
